import NavBarNotRegistred from "./Components/NavBarNotRegistred"
import NavBarRegistred from "./Components/NavBarRegistred"
import "./styles.scss"

interface HeaderTemplate {
  secondary: boolean
  hideRegis?: boolean
}

const NavBarChildren = ({
  secondary = false,
  hideRegis = true,
}: HeaderTemplate) => {
  return (
    <>
      {!secondary ? (
        <NavBarRegistred />
      ) : (
        <NavBarNotRegistred hideRegis={hideRegis} />
      )}
    </>
  )
}

export default NavBarChildren
